export default __webpack_public_path__ + "static/media/chat7.b95052dd.png";